module.exports = __webpack_public_path__ + "static/img/i5.53955e48.png";